import { useEffect, useState } from 'react';
import ShipmentsApi from '../../../../API/shipment/shipments-api';
import { PopUp, Row } from '../../../../components/Basic/Blocks';
import { DateInput, InputLabel, Select } from '../../../../components/Basic/Inputs';
import { H2 } from '../../../../components/Basic/WrapsStyle';
import { MARKETS_ALL, MARKETS_MAP, TYPE_BUTTONS, WAREHOUSE_LIST } from '../../../../constans';
import styles from './styles.module.scss';
import { Button } from '../../../../components/Basic/Buttons';

const LIST_EXPRESS = [
  { name: 'Нет', value: false },
  { name: 'Да', value: true },
];

const CreateShipmentPopUp = ({ close = () => { } }) => {
  const [data, setData] = useState({
    time_scheduled: null,
    info: '',
    market: '',
  });
  const [market, setMarket] = useState(Object.keys(MARKETS_ALL)[0]);
  const [shop, setShop] = useState();
  const [sklad, setSklad] = useState(WAREHOUSE_LIST[0]);

  const [isExpress, setIsExpress] = useState({ name: 'Нет', value: false });

  const validate = () => {
    return data.time_scheduled;
  };

  const clickAdd = () => {
    if (validate()) {
      ShipmentsApi.createShipment({ data: { market: market.toLowerCase(), shop: MARKETS_MAP[shop], time_scheduled: data.time_scheduled, isExpress: isExpress.value, skladName: sklad.name } }).then((r) => {
        close();
      });
    }
  };

  useEffect(() => {
    setMarket(Object.keys(MARKETS_ALL)[0]);
  }, []);

  useEffect(() => {
    if (market) {
      setShop(MARKETS_ALL[market][0]);
    }
    if (market === 'Sber' || market === 'Wb') {
      setIsExpress(LIST_EXPRESS[0]);
    }
  }, [market]);

  return (
    <PopUp close={close} clickOutside={false} className={styles.pop_up}>
      <H2 style={{ marginBottom: '20px' }}>Добавить новую отгрузку</H2>
      <Row>
        <div style={{ marginRight: '25px' }}>
          <Select
            list={Object.keys(MARKETS_ALL)}
            select={market}
            label="Площадка"
            onSelect={(v) => setMarket(v)}
            width={'150px'}
          />
        </div>
        <div style={{ marginRight: '25px' }}>
          <Select
            list={LIST_EXPRESS}
            select={isExpress}
            label="Экспресс"
            valueFn={(v) => v.name}
            disabled={market === 'Sber' || market === 'Wb'}
            onSelect={(v) => setIsExpress(v)}
            width={'150px'}
          />
        </div>
        <div>
          <Select
            list={WAREHOUSE_LIST}
            select={sklad}
            label="Склад отгрузки"
            valueFn={(v) => v.warehouse}
            onSelect={(v) => setSklad(v)}
            width={'200px'}
          />
        </div>
      </Row>
      <Row style={{ marginTop: '20px' }}>
        <InputLabel style={{ marginRight: '20px' }}>Дата отгрузки</InputLabel>
        <DateInput onChange={(v) => setData({ ...data, time_scheduled: v })} />
      </Row>

      <Row style={{ marginTop: '30px' }}>
        <Button
          type={TYPE_BUTTONS.BLUE}
          disabled={!data.time_scheduled}
          style={{
            marginRight: '15px',
          }}
          onClick={!data.time_scheduled ? () => { } : clickAdd}
        >
          Добавить
        </Button>
        <Button type={TYPE_BUTTONS.GREY} onClick={close}>
          Отменить
        </Button>
      </Row>
    </PopUp>
  );
};

export default CreateShipmentPopUp;
